"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderBadge = void 0;
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const ProviderBadges_styles_1 = require("./ProviderBadges.styles");
const util_1 = require("../common/util");
const utils_1 = require("./lib/utils");
exports.ProviderBadge = (0, intl_1.injectIntl)(({ intl, badge, renderLocation }) => {
    let label;
    let field;
    let color = 'default';
    if (typeof badge === 'string') {
        field = badge;
    }
    else {
        ({ label, field, color = color } = badge);
    }
    const badgeText = react_1.default.useMemo(() => {
        return (0, utils_1.formatBadgeText)(label ||
            intl.formatMessage({
                id: `provider.badge.${field}`,
                defaultMessage: field,
                description: 'Badge text for the specified field'
            }));
    }, [intl, label, field]);
    if (renderLocation === 'provider_profile') {
        return (react_1.default.createElement(ProviderBadges_styles_1.ProviderProfileBadge, { color: color, "data-testid": `badge_chip_${field}`, label: badgeText, size: "small" }));
    }
    return (react_1.default.createElement(ProviderBadges_styles_1.BadgeContainer, null,
        react_1.default.createElement(ProviderBadges_styles_1.Badge, null, badgeText)));
});
const ProviderBadges = ({ provider, badgeFields, renderLocation }) => {
    // Get the badges for the provider
    const badges = (0, util_1.getProviderBadgeFields)(provider, badgeFields);
    return (react_1.default.createElement(ProviderBadges_styles_1.BadgeWrapper, { "data-testid": "ProviderBadges" }, badges.map((badge) => {
        return (react_1.default.createElement(exports.ProviderBadge, { key: badge.field, badge: badge, renderLocation: renderLocation }));
    })));
};
exports.default = ProviderBadges;
//# sourceMappingURL=ProviderBadges.js.map